
export default {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.login': 'Login',
  'nav.register': 'Register',
  'nav.dashboard': 'Dashboard',
  'nav.investments': 'Investments',
  
  // Hero Section
  'hero.title': 'Get Loans Up to 20x Your Share Value',
  'hero.subtitle': 'Purchase shares between your local currency minimum and maximum to qualify for loans up to 20x your share value. 100% returns on your investment.',
  'hero.cta': 'Get Started',
  
  // Features
  'features.title': 'Why Choose Us',
  'features.loans.title': 'Quick Loans',
  'features.loans.desc': 'Get loans up to 20x your share value',
  'features.returns.title': 'High Returns',
  'features.returns.desc': 'Earn 100% returns on your investment',
  'features.secure.title': '100% Secure',
  'features.secure.desc': 'Registered and verified company',
  
  // How It Works
  'howItWorks.title': 'How It Works',
  'howItWorks.step1.title': 'Register',
  'howItWorks.step1.desc': 'Create your account for free',
  'howItWorks.step2.title': 'Buy Shares',
  'howItWorks.step2.desc': 'Purchase shares in your local currency',
  'howItWorks.step3.title': 'Get Loan',
  'howItWorks.step3.desc': 'Apply for loans up to 20x your shares',
  'howItWorks.step4.title': 'Earn Returns',
  'howItWorks.step4.desc': 'Get 100% returns on your investment',
  
  // Dashboard
  'dashboard.welcome': 'Welcome',
  'dashboard.overview': 'Account Overview',
  'dashboard.shares': 'Shares Acquired',
  'dashboard.loanBalance': 'Current Loan Balance',
  'dashboard.availableLoan': 'Available Loan',
  'dashboard.totalReturns': 'Total Returns',
  'dashboard.purchaseShares': 'Purchase Shares',
  'dashboard.applyLoan': 'Apply for Loan',
  'dashboard.viewInvestments': 'View Investments',
  
  // Forms
  'form.email': 'Email',
  'form.password': 'Password',
  'form.confirmPassword': 'Confirm Password',
  'form.fullName': 'Full Name',
  'form.phone': 'Phone Number',
  'form.country': 'Country',
  'form.submit': 'Submit',
  'form.cancel': 'Cancel',
  
  // Buttons
  'btn.getStarted': 'Get Started',
  'btn.learnMore': 'Learn More',
  'btn.contactUs': 'Contact Us',
  'btn.buyNow': 'Buy Now',
  'btn.apply': 'Apply',
  
  // Support
  'support.title': 'Telegram Support',
  'support.desc': 'Contact us on Telegram for quick support',
  'support.available': 'Available 24/7',
  
  // Footer
  'footer.rights': 'All rights reserved',
  'footer.company': 'Company',
  'footer.support': 'Support',
  'footer.legal': 'Legal'
};
